/* eslint-disable max-len */
// defined questions and their default values
export const DIGITAL_ASSET_QUESTION_LABELS = Object.freeze({
  willPurchaseDigitalAssets: 'Will AV be purchasing digital assets (tokens, NFT’s, etc) as part of this investment, or entering into an agreement to acquire digital assets in the future (SAFT, warrants, etc)?',
  requiresDigitalAssetInvestment: 'Is AV required to invest in this deal via digital assets (in full or in part)?',
  requiresOffshoreEntityInvestment: 'Is AV required to invest in this deal via our offshore entity?',
  digitalAssetInvestmentExplanation: 'Please explain the details of how AV must invest in this deal (digital assets vs. cash). Please indicate the exact digital asset (i.e. USDC) that will be used to make this investment.',
  portfolioCompanyWalletAddress: 'Please enter the portco’s wallet address:',
});

const questionList = [
  {
    label: DIGITAL_ASSET_QUESTION_LABELS.willPurchaseDigitalAssets,
    value: null,
  },
  {
    label: DIGITAL_ASSET_QUESTION_LABELS.requiresDigitalAssetInvestment,
    value: null,
  },
  {
    label: DIGITAL_ASSET_QUESTION_LABELS.requiresOffshoreEntityInvestment,
    value: null,
  },
  {
    label: DIGITAL_ASSET_QUESTION_LABELS.digitalAssetInvestmentExplanation,
    value: '',
  },
  {
    label: DIGITAL_ASSET_QUESTION_LABELS.portfolioCompanyWalletAddress,
    value: '',
  },
];

export const createDigitalAssetQuestions = (questions = []) => {
  const savedQuestions = Array.isArray(questions) ? questions : [];

  return questionList.map((question) => {
    const matchingQuestion = savedQuestions.find((savedQuestion) => (
      savedQuestion && savedQuestion.label === question.label
    ));

    if (matchingQuestion) {
      return { ...question, value: matchingQuestion.value };
    }

    return { ...question };
  });
};

const digitalAssetGatingQuestionLabels = new Set([
  DIGITAL_ASSET_QUESTION_LABELS.willPurchaseDigitalAssets,
  DIGITAL_ASSET_QUESTION_LABELS.requiresDigitalAssetInvestment,
]);
const digitalAssetGatingQuestions = questionList.filter((question) => (
  digitalAssetGatingQuestionLabels.has(question.label)
));

export const getDigitalAssetGatingQuestions = (questions = []) => (
  digitalAssetGatingQuestions
    .map((definedQuestion) => {
      const savedQuestions = Array.isArray(questions) ? questions : [];
      const savedQuestion = savedQuestions.find((question) => (
        question.label === definedQuestion.label
      ));

      return savedQuestion && { ...definedQuestion, ...savedQuestion };
    })
    .filter(Boolean)
);

export default questionList;
